export default "__VITE_ASSET__qvTpgjzw__"